import React from 'react'
import ViewActiveKanban from '../../components/Report/ActiveKanban/ViewActiveKanban'
import TableViewActiveKanban from '../../components/Report/ActiveKanban/TableViewActiveKanban'
import { Divider, Typography } from 'antd'

const ActiveKanban = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Active Kanban
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <ViewActiveKanban userData={userData} />
        </>
    )
}

export default ActiveKanban